<template>
  <div>
    <div>应用拓展 - 话题讨论</div>

    <div class="list">
      <div v-for="item in config.list" :key="item.id">
        <div>ID: {{item.id}}</div>
        <div class="pre-wrap">讨论话题: {{item.topic}}</div>
        <div class="pre-wrap">AI预设: {{item.ai_preset}}</div>
        <div class="pre-wrap">练习目标: {{item.goal}}</div>
        <div class="pre-wrap">练习模式: <span v-if="item.mode===1">目标导向/简单模式</span><span v-else>练习导向/自由讨论模式</span></div>
        <div class="pre-wrap">GPT第一句话: {{item.prompt}}</div>
        <div class="pre-wrap">GPT判定: {{item.endpoint}}</div>
      </div>
    </div>

    <div class="pre-wrap">进入消息: {{config.enter_msg}}</div>
    <div class="pre-wrap">需要确认: {{config.enter_ready}}</div>
    <div class="pre-wrap">第一条消息: {{config.first_msg}}</div>
    <div class="pre-wrap">下一个消息: {{config.next_msg}}</div>
    <div class="pre-wrap">完成模块消息: {{config.finish_msg || '无'}}</div>
    <SttFormat :formats="config.stt_format"/>
    <TtsFormat :formats="config.tts_format"/>

  </div>
</template>

<script>
import SttFormat from "./stt_format.vue";
import TtsFormat from "./tts_format.vue";

export default {
  name: "ai_topic",
  components: {TtsFormat,SttFormat},
  props: {
    entity: {
      type: Object,
      default: () => {
        return {}
      }
    },
    config: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
}
</script>